export default function PinDots({filled, total = 4}) {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 24,
                minHeight: 16,
                margin: '30px 0'
            }}
        >
            {Array.from({length: total}, (_, i) => (
                <span
                    key={i}
                    className={'border-dark' + (i < filled ? ' bg-dark' : '')}
                    style={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        display: 'inline-block',
                        border: '1px solid #0063d6',
                        transition: 'background-color 0.1s'
                    }}
                />
            ))}
        </div>
    );
}
